import KinAvatar from "./KinAvatar";

const OfflineScreen = () => {
  return (
    <div
      className="fixed inset-0 z-[9999] flex flex-col items-center justify-center px-6"
      style={{ background: "#F8F8FF" }}
    >
      <div className="mb-6">
        <KinAvatar size="lg" variant="dark" />
      </div>
      <h1
        className="font-display text-center mb-3"
        style={{
          fontSize: 28,
          fontWeight: 400,
          letterSpacing: "-0.5px",
          color: "#1C1A3E",
        }}
      >
        No internet connection
      </h1>
      <p
        className="font-body text-center"
        style={{
          fontSize: 15,
          color: "#1C1A3E",
          lineHeight: 1.5,
          maxWidth: 320,
        }}
      >
        Kin needs wifi or data to work her magic. Reconnect and I'll be right here. 💜
      </p>
    </div>
  );
};

export default OfflineScreen;
